import { getEnvVariable } from "../../modules/environmentalList"

const systemadmindrawer = {
    "type": "drawer",
    "order": 2,
    "key": "drawer",
    "options": {
        "alignitem": "left",
        //"title": "drawer",
        "icon": "alarm",
        "open": true,
        "anchor": 'left',
        "admin": 'Y',
        "items": [
            {
                "type": "tree",
                "title": "Dashboard",
                //"icon": "fa fa-pie-chart",
                "materialicon": "dashboard",
                "key": "Dashboard",
                "items": [
                    {
                        "type": "menu",
                        "title": "Notifications",
                        "icon": "notifications_active",
                        "materialicon": "notifications_active",
                        "link": "/notifications",
                        "key": "Notifications",
                        "style": {
                            'color': '#00bfa5'
                        }
                    }, 
                    {
                        "type": "menu",
                        "title": "Invoice Dashboard",
                        "icon": "assessment",
                        "materialicon": "assessment",
                        "link": "/billingdashboard",
"reloadtab": true,
                        "key": "billingdashboard",
                        "style": {
                            'color': '#c158dc'
                        }
                    },
                    
                ]

            },
                    {
                        "type": "tree",
                        "title": "My Portal",
                        "materialicon": "corporate_fare",
                        "key": "MyPortal",
                        "items": [
                            {
                                "type": "menu",
                                "title": "Search",
                                "icon": "search",
                                "materialicon": "search",
                                "link": "/search",
"reloadtab": true,
                                "key": "Search",
                                "style": {
                                    'color': '#61A5DC'
                                }
                            },
                    {
                        "type": "recordmenu",
                        "title": "Records",
                        "materialicon": "source",
                        "key": "Records",
                        "items": [],
                        "lskey": "submodule"
                    },

                    
                    {
                        "type": "menu",
                        "title": "Applicants",
                        "icon": "fa fa-building",
                        "link": "/Administration/companies",
                        "key": "companies",
                        "materialicon": "apartment",
                        "style": {
                            'color': '#ea156d'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "External Contacts",
                        "key": "contacts",
                        "link": "/Administration/globalexternalcontacts",
                        "icon": "fa fa-user-circle-o",
                        "materialicon": "portrait",
                        "style": {
                            'color': '#006064'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Reports",
                        "icon": "fa fa-files-o",
                        "link": getEnvVariable('ReportsUI'),
                        "key": "reports",
                        "newtab": true,
                        "materialicon": "post_add",
                        "style": {
                            'color': '#827717'
                        }
                    }, 
                ]

            },
            {
                "type": "tree",
                "title": "Administration",
                "materialicon": "spellcheck",
                "key": "Administration",
                "items": [
                    {
                        "type": "menu",
                        "title": "Users",
                        "icon": "fa fa-users",
                        "link": "/Administration/agencyusers",
                        "key": "AgencyUsers",
                        "materialicon": "person",
                        "style": {
                            'color': '#01579b'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Roles",
                        "key": "roles",
                        "link": "/Administration/roles",
                        "icon": "fa fa-user-circle-o",
                        "materialicon": "manage_accounts",
                        "style": {
                            'color': '#004d40'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Groups",
                        "key": "groups",
                        "link": "/Administration/groups",
                        "icon": "fa fa-users",
                        "materialicon": "device_hub",
                        "style": {
                            'color': '#3f51b5'
                        }
                    },
                    // {
                    //     "type": "menu",
                    //     "title": "Regions",
                    //     "key": "regions",
                    //     "link": "/Administration/regions",
                    //     "icon": "fa fa-map",
                    //     "materialicon": "streetview",
                    //     "style": {
                    //         'color': '#61A5DC'
                    //     }
                    // },
                    {
                        "type": "menu",
                        "title": "Districts",
                        "key": "districts",
                        "link": "/Administration/districts",
                        "icon": "fa fa-map",
                        "materialicon": "map",
                        "style": {
                            'color': '#c158dc'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Parish",
                        "key": "sites",
                        "link": "/Administration/counties",
                        "icon": "fa fa-globe",
                        "materialicon": "settings_system_daydream",
                        "style": {
                            'color': '#006064'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Email Groups",
                        "key": "groupemails",
                        "link": "/Administration/groupemails",
                        "icon": "fa fa-domain",
                        "materialicon": "email",
                        "style": {
                            'color': '#0c755b'
                        }
                    },
                    
                    {
                        "type": "menu",
                        "title": "Invoice Cycles",
                        "key": "invoicecycles",
                        "link": "/Administration/invoicecycles",
                        "icon": "fa fa-receipt",
                        "materialicon": "attach_money",
                        "style": {
                            'color': '#140c47'
                        }
                    },
                 
                    // {
                    //     "type": "menu",
                    //     "title": "Consultants",
                    //     "icon": "fa fa-building",
                    //     "link": "/Administration/consultants",
                    //     "key": "consultants",
                    //     "materialicon": "connect_without_contact",
                    //     "style": {
                    //         'color': '#cddc39'
                    //     }
                    // },
                    // {
                    //     "type": "menu",
                    //     "title": "Project Messages",
                    //     "key": "projectmessages",
                    //     "link": "/Administration/projectmessages",
                    //     "icon": "fa fa-domain",
                    //     "materialicon": "message",
                    //     "style": {
                    //         'color': '#940786'
                    //     }
                    // },
                    {
                        "type":"menu",
                        "title": "Authorization",
                        "key": "Authorization",
                        "link": "/Administration/authorizations",
                        "reloadtab": true,
                        "icon": "fa fa-globe",
                        "materialicon": "vpn_key",
                        "style": {
                            'color': '#c158dc'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Registrations",
                        "key": "registrationrequest",
                        "link": "/Administration/registrationrequest",
                        "icon": "fa fa-caret-square-o-right",
                        "materialicon": "how_to_vote",
                        "style": {
                            'color': '#9fa8da'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Invoice Management",
                        "key": "downloadallinvoices",
                        "link": "/Administration/invoicemanagementtabs",
                        "icon": "fa fa-sync-alt",
                        "materialicon": "request_quote",
                        "style": {
                            'color': '#9fa8da'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Announcements",
                        "key": "announcements",
                        "link": "/Administration/announcements",
                        "icon": "fa fa-sync-alt",
                        "materialicon": "campaign",
                        "style": {
                            'color': '#f51515ff'
                        }
                    },

                ]
            },
            {
                "type": "tree",
                "title": `Master Settings`,
                "icon": "fa fa-lock",
                "key": "epssettings",
                "materialicon": "settings_applications",
                "style": {
                    'color': '#2196f3'
                }, //#2196f3
                "items": [{
                    "type": "menu",
                    "title": "Permit Status",
                    "key": "applicationstatus",
                    "link": "/Administration/applicationstatus",
                    "icon": "fa fa-iconspinner",
                    "materialicon": "rotate_right",
                    "style": {
                        'color': '#00796b'
                    }
                },
                {
                    "type": "menu",
                    "title": "Attachment Types",
                    "key": "attachmenttypes",
                    "link": "/Administration/attachmenttypes",
                    "icon": "fa fa-paperclip",
                    "materialicon": "attach_file",
                    "style": {
                        'color': '#b26a00'
                    }
                },
                {
                    "type": "menu",
                    "title": "Image Types",
                    "key": "imagetypes",
                    "link": "/Administration/imagetypes",
                    "icon": "fa fa-file-image-o",
                    "materialicon": "wallpaper",
                    "style": {
                        'color': '#ffb300'
                    }
                },
                {
                    "type": "menu",
                    "title": "Permit Types",
                    "key": "sitepermittypes",
                    "link": "/Administration/applicationtypes",
                    "icon": "fa fa-address-card-o",
                    "materialicon": "language",
                    "style": {
                        'color': '#a5d6a7'
                    }
                },
                {
                    "type": "menu",
                    "title": "Master Templates",
                    "key": "notices",
                    "link": "/Administration/masternotices",
                    "icon": "fa fa-sticky-note",
                    "materialicon": "document_scanner",
                    "style": {
                        'color': '#ab003c'
                    }
                },
                {
                    "type": "menu",
                    "title": "Project Downloads",
                    "key": "projectdownloads",
                    "link": "/Administration/projectdownloads",
                    "icon": "fa fa-users",
                    "materialicon": "download",
                    "style": {
                        'color': '#3f51b5'
                    }
                },
                {
                    "type": "menu",
                    "title": "Notice Types",
                    "key": "notices",
                    "link": "/Administration/noticestypes",
                    "icon": "fa fa-sticky-note",
                    "materialicon": "article",
                    "style": {
                        'color': '#8bc34a'
                    }
                },
                {
                    "type": "menu",
                    "title": "Notification Settings",
                    "key": "notificationsettings",
                    "link": "/Administration/notificationsettings",
                    "icon": "fa fa-bell-o",
                    "materialicon": "notifications_active",
                    "style": {
                        'color': '#40c4ff'
                    }
                },
                {
                    "type": "menu",
                    "title": "Domains",
                    "key": "domains",
                    "link": "/Administration/domains",
                    "icon": "fa fa-domain",
                    "materialicon": "domain",
                    "style": {
                        'color': '#a98274'
                    }
                },
                {
                    "type": "menu",
                    "title": "Layers",
                    "key": "layers",
                    "link": "/Administration/layers",
                    "icon": "fa fa-domain",
                    "materialicon": "layers",
                    "style": {
                        'color': '#c85a54'
                    }
                },
                ]
            },
            {
                "type": "tree",
                "title": `Site Settings`,
                "icon": "fa fa-lock",
                "key": "epssettings",
                "materialicon": "engineering",
                "style": {
                    'color': '#2196f3'
                }, //#2196f3
                "items": [
                    {
                        "type": "menu",
                        "title": "Master Sections",
                        "key": "sections",
                        "link": "/Administration/mastersections",
                        "icon": "fa fa-columns",
                        "materialicon": "view_week",
                        "style": {
                            'color': '#00c853'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Master Fields",
                        "key": "masterFieldsList",
                        "link": "/Administration/masterfieldslist",
                        "icon": "fa fa-list-alt",
                        "materialicon": "view_module",
                        "style": {
                            'color': '#e65100'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Master Permit Types",
                        "key": "masterpermittypes",
                        "link": "/Administration/masterpermittypes",
                        "icon": "fa fa-id-badge",
                        "materialicon": "verified_user",
                        "style": {
                            'color': '#795548'
                        }
                    },

                    {
                        "type": "menu",
                        "title": "Configurations",
                        "key": "settings",
                        "link": "/Administration/settings",
                        "icon": "fa fa-domain",
                        "materialicon": "settings_suggest",
                        "style": {
                            'color': '#5ddef4'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Invoice Settings",
                        "key": "invoicesettings",
                        "link": "/Administration/invoicepermitrenewals",
                        "icon": "fa fa-domain",
                        "materialicon": "local_atm",
                        "style": {
                            'color': '#a98274'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Billing Config",
                        "key": "billingconfiguration",
                        "link": "/Administration/billingconfiguration",
                        "icon": "fa fa-domain",
                        "materialicon": "currency_exchange",
                        "style": {
                            'color': '#CA68C4'
                        }
                    },
                    // {
                    //     "type": "menu",
                    //     "title": "Sidebar Rules",
                    //     "key": "settings",
                    //     "link": "/Administration/sidebarbr",
                    //     "icon": "fa fa-domain",
                    //     "materialicon": "ballot",
                    //     "style": {
                    //         'color': '#aeea00'
                    //     }
                    // },

                ]
            }



        ]
    }
}

export default systemadmindrawer
